/*
 * Product page enhancements. Everything here is additive — the page is fully
 * usable with this file blocked:
 *
 *   - The volume-price row is highlighted as the quantity changes. Without JS
 *     the tiers still read as the price table they are.
 *   - The mobile gallery indicator follows native scroll-snap swipes and its
 *     labels smoothly scroll to a slide. Without JS the images are still
 *     swipeable; only the non-functional indicator is hidden.
 *
 *   - Variant choices swap the buy block in place (Section Rendering).
 *     Without JS every value is a plain ?variant= link.
 *   - Desktop thumbnails switch the image on hover.
 *
 * Gallery switching, zoom and add-to-cart work without JavaScript (see
 * sections/main-product.liquid). The delivery-date countdown that lived here
 * was removed 2026-10-07 together with the date itself.
 */
(function () {
  'use strict';

  var strings = window.themeStrings || {};

  function interpolate(template, values) {
    return Object.keys(values || {}).reduce(function (text, key) {
      return text.split('{' + key + '}').join(String(values[key]));
    }, template || '');
  }

  var qtyInput = document.getElementById('pdp-qty');
  var tierRows = Array.prototype.slice.call(document.querySelectorAll('[data-tier-min]'));

  function updateTiers() {
    /* Hämtas om varje gång: variantbytet (nedan) ersätter köpblocket. */
    qtyInput = document.getElementById('pdp-qty');
    tierRows = Array.prototype.slice.call(document.querySelectorAll('[data-tier-min]'));
    if (!qtyInput || tierRows.length === 0) return;

    var quantity = parseInt(qtyInput.value, 10) || 1;
    var activeIndex = -1;

    tierRows.forEach(function (row, index) {
      var minimum = parseInt(row.getAttribute('data-tier-min'), 10);
      if (!isNaN(minimum) && quantity >= minimum) activeIndex = index;
    });

    tierRows.forEach(function (row, index) {
      row.classList.toggle('pdp-tiers__row--active', index === activeIndex);
    });
  }

  /*
   * Keeps the "N i kundvagnen" line honest after an AJAX add. cart.js emits
   * cart:updated with the cart as the server now has it; this counts only the
   * lines for the variant this page is showing.
   */
  function updateInCart(cart) {
    var el = document.querySelector('[data-in-cart]');
    if (!el || !cart || !cart.items) return;

    var variantId = el.getAttribute('data-variant-id');
    var quantity = cart.items.reduce(function (sum, item) {
      return String(item.variant_id) === variantId ? sum + item.quantity : sum;
    }, 0);

    el.textContent = interpolate(strings.inCartCount || '{count} i kundvagnen', { count: quantity });
    el.hidden = quantity === 0;
  }

  /*
   * The zoom overlay is pure :target CSS and needs no JavaScript to open. What
   * it cannot do on its own is stop the page behind it from being tabbed
   * through while it covers the screen. When JS is available we give it the
   * same treatment the cart drawer gets: focus moves in, Tab is trapped, Escape
   * closes. Without JS the overlay still opens and closes by link.
   */
  function zoomTrap(event) {
    var open = document.querySelector('.pdp-zoom:target');
    if (!open) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      window.location.hash = '#pdp-galleri';
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = Array.prototype.slice.call(open.querySelectorAll('a[href]'));
    if (focusable.length === 0) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function focusZoom() {
    var open = document.querySelector('.pdp-zoom:target');
    if (!open) return;
    var close = open.querySelector('.pdp-zoom__close');
    if (close) close.focus();
  }

  document.addEventListener('cart:updated', function (event) {
    updateInCart(event.detail);
  });

  if (document.querySelector('.pdp-zoom')) {
    document.addEventListener('keydown', zoomTrap, true);
    window.addEventListener('hashchange', focusZoom);
  }

  if (qtyInput && tierRows.length > 0) {
    updateTiers();
    document.addEventListener('input', function (event) {
      if (event.target && event.target.id === 'pdp-qty') updateTiers();
    });
    /* The stepper buttons set input.value directly (see cart.js), which fires
       no input event — so re-check after any click in the stepper. */
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-qty-stepper]')) updateTiers();
    });
  }

  /* Mobile product gallery. CSS turns the stage into a native scroll-snap
     strip below 600px, so touch scrolling works before this file loads and
     even if it is blocked. JavaScript owns only the two-way synchronisation:
     swipe -> checked dot, and dot/keyboard -> smooth scroll.

     A passive scroll listener plus requestAnimationFrame avoids layout work
     more than once per painted frame. Shots are all exactly one stage wide,
     but offsetLeft is used instead of index * width so the calculation stays
     correct if the gallery ever gains a gap. */
  var galleryStage = document.querySelector('[data-gallery-stage]');
  var galleryShots = galleryStage
    ? Array.prototype.slice.call(galleryStage.querySelectorAll('[data-gallery-shot]'))
    : [];
  var galleryRadios = Array.prototype.slice.call(document.querySelectorAll('.pdp-gallery__radio'));
  var mobileGallery = window.matchMedia('(max-width: 600px)');

  if (galleryStage && galleryShots.length > 1 && galleryRadios.length === galleryShots.length) {
    var galleryQueued = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    var nearestGalleryIndex = function () {
      var nearest = 0;
      var distance = Infinity;

      galleryShots.forEach(function (shot, index) {
        var nextDistance = Math.abs(shot.offsetLeft - galleryStage.scrollLeft);
        if (nextDistance < distance) {
          distance = nextDistance;
          nearest = index;
        }
      });

      return nearest;
    };

    var syncGalleryIndicator = function () {
      galleryQueued = false;
      if (!mobileGallery.matches) return;

      var activeRadio = galleryRadios[nearestGalleryIndex()];
      if (activeRadio && !activeRadio.checked) activeRadio.checked = true;
    };

    var queueGallerySync = function () {
      if (galleryQueued || !mobileGallery.matches) return;
      galleryQueued = true;
      requestAnimationFrame(syncGalleryIndicator);
    };

    var scrollToCheckedGalleryShot = function (behavior) {
      if (!mobileGallery.matches) return;

      var checkedIndex = galleryRadios.findIndex(function (radio) {
        return radio.checked;
      });
      var shot = galleryShots[checkedIndex < 0 ? 0 : checkedIndex];
      if (!shot) return;

      galleryStage.scrollTo({ left: shot.offsetLeft, behavior: behavior });
    };

    galleryRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        scrollToCheckedGalleryShot(reducedMotion.matches ? 'auto' : 'smooth');
      });
    });

    var handleGalleryMode = function () {
      if (mobileGallery.matches) scrollToCheckedGalleryShot('auto');
    };

    galleryStage.addEventListener('scroll', queueGallerySync, { passive: true });
    if (typeof mobileGallery.addEventListener === 'function') {
      mobileGallery.addEventListener('change', handleGalleryMode);
    } else {
      mobileGallery.addListener(handleGalleryMode);
    }
    handleGalleryMode();
  }

  /* Desktop: miniatyren byter huvudbilden redan vid hover, som hos Amazon
     (Elia 2026-10-07). Miniatyrerna är <label> till radioknapparna som CSS
     visar bilden efter, så hover markerar bara samma radio som ett klick
     hade gjort. Endast med riktig hover — på pekskärm hade det första
     trycket både "hovrat" och klickat. */
  var hoverGallery = window.matchMedia('(hover: hover) and (pointer: fine)');
  /* Huvudbilderna är lazy. Utan förladdning blev rutan tom en stund vid
     första hover, så de hämtas när musen når miniatyrraden. */
  var thumbRow = document.querySelector('.pdp-gallery__thumbs');
  if (thumbRow) {
    thumbRow.addEventListener('mouseenter', function () {
      if (!hoverGallery.matches) return;
      Array.prototype.forEach.call(document.querySelectorAll('[data-gallery-shot] img[loading="lazy"]'), function (img) {
        img.loading = 'eager';
      });
    }, { once: true });
  }
  Array.prototype.forEach.call(document.querySelectorAll('.pdp-gallery__thumb'), function (thumb) {
    thumb.addEventListener('mouseenter', function () {
      if (!hoverGallery.matches) return;
      var radio = document.getElementById(thumb.getAttribute('for'));
      if (radio && !radio.checked) radio.checked = true;
    });
  });

  /* Desktop: miniatyrraden är lika hög som huvudbilden och skrollar. Små
     pilknappar visar att det finns fler bilder och skrollar raden; de syns
     bara när raden svämmar över, och bara åt det håll det finns mer. */
  var thumbCol = document.querySelector('.pdp-gallery__thumbs');
  var wideGallery = window.matchMedia('(min-width: 601px)');
  if (thumbCol) {
    var makeNav = function (dir) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'pdp-thumbs-nav pdp-thumbs-nav--' + dir;
      button.hidden = true;
      button.setAttribute('aria-label', dir === 'down' ? strings.moreImages || 'Fler bilder' : strings.previousImages || 'Föregående bilder');
      button.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' +
        (dir === 'down' ? 'm6 9 6 6 6-6' : 'm6 15 6-6 6 6') +
        '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      button.addEventListener('click', function () {
        thumbCol.scrollBy({ top: (dir === 'down' ? 1 : -1) * thumbCol.clientHeight * 0.8, behavior: 'smooth' });
      });
      thumbCol.parentNode.appendChild(button);
      return button;
    };
    var navUp = makeNav('up');
    var navDown = makeNav('down');
    var syncThumbNav = function () {
      var max = thumbCol.scrollHeight - thumbCol.clientHeight;
      var overflowing = wideGallery.matches && max > 2;
      navUp.hidden = !overflowing || thumbCol.scrollTop <= 2;
      navDown.hidden = !overflowing || thumbCol.scrollTop >= max - 2;
      thumbCol.classList.toggle('is-more-below', overflowing && !navDown.hidden);
      thumbCol.classList.toggle('is-more-above', overflowing && !navUp.hidden);
    };
    thumbCol.addEventListener('scroll', syncThumbNav, { passive: true });
    window.addEventListener('resize', syncThumbNav, { passive: true });
    window.addEventListener('load', syncThumbNav);
    syncThumbNav();
  }

  /* Fasta köpraden på mobil. Visas först när det riktiga köpblocket skrollat
     förbi — annars konkurrerar två identiska knappar om samma klick. Raden
     ligger `hidden` i markupen, så utan JavaScript finns den inte alls.

     Varför inte IntersectionObserver: den fyrar bara när ett tröskelvärde
     KORSAS. Hoppar sidan förbi köpblocket i ett steg — ankarlänk, tillbaka-
     navigering som återställer skrollpositionen, "hoppa till specifikation" —
     går elementet från "under vyn, ej synligt" till "ovanför vyn, ej synligt"
     utan att något tröskelvärde korsas, och callbacken kallas aldrig. Raden
     uteblev då helt. Verifierat: en observer på köpblocket loggade en enda
     gång, vid registreringen.

     Lyssnaren är därför en vanlig scroll, men passiv och rAF-grindad: högst
     en läsning per bildruta, och den läser bara ett getBoundingClientRect. */
  var stickyBar = document.querySelector('[data-pdp-sticky]');
  var buyForm = document.querySelector('.pdp-buy__form');
  var stickyQueued = false;

  /* Raden och formuläret hämtas om vid varje läsning: variantbytet ersätter
     båda, och en kvarhängande referens till det gamla formuläret mäter 0 och
     hade visat raden hela tiden. Raden kan också saknas (slutsåld variant,
     ovald storlek) och dyka upp efter ett byte. */
  var syncSticky = function () {
    stickyQueued = false;
    stickyBar = document.querySelector('[data-pdp-sticky]');
    buyForm = document.querySelector('.pdp-buy__form');
    if (!stickyBar || !buyForm) return;
    stickyBar.hidden = false;
    var stickyVisible = buyForm.getBoundingClientRect().bottom <= 0;
    stickyBar.classList.toggle('pdp-sticky--visible', stickyVisible);
    stickyBar.setAttribute('aria-hidden', stickyVisible ? 'false' : 'true');
  };

  var queueSticky = function () {
    if (stickyQueued) return;
    stickyQueued = true;
    requestAnimationFrame(syncSticky);
  };

  /* `hidden` is the no-JS fallback. Once scripting is active the element
     stays rendered just below the viewport so CSS can animate both ways. */
  if (buyForm) {
    syncSticky();
    window.addEventListener('scroll', queueSticky, { passive: true });
    window.addEventListener('resize', queueSticky, { passive: true });
  }

  /* Lagerbevakning. Adressen går till hjartgruppen-automations
     (api/stock-watch.js), som lägger en rad i `stock_watch`; cron-jobbet
     `stock-notify` mejlar av sig själv när varianten är säljbar igen.

     Till 2026-08-07 var rutan ett Shopify-kontaktformulär som mejlade butiken,
     och utskicket till kunden var alltså handarbete som aldrig blev av.

     Kroppen är formulärkodad och inte JSON. Det gör anropet till en "simple
     request" som slipper CORS-preflight — annars hade varje anmälan kostat en
     extra tur över Atlanten innan kunden fick sitt kvitto. */
  /* En funktion och inte en engångsblock: variantbytet kan ta in ett nytt
     bevakningsformulär (bytet till en slutsåld storlek). */
  function initWatch(watchForm) {
    if (!watchForm || watchForm.dataset.watchBound === 'true') return;
    watchForm.dataset.watchBound = 'true';
    var watchButton = watchForm.querySelector('[data-stock-watch-submit]');
    var watchStatus = watchForm.querySelector('[data-stock-watch-status]');
    var watchRow = watchForm.querySelector('[data-stock-watch-row]');
    var watchLede = watchForm.querySelector('[data-stock-watch-lede]');
    var watchEmail = watchForm.querySelector('input[type="email"]');
    // Butikens egen adress — temat delas av flera butiker och felmeddelandet
    // fick inte skicka Medstuffs kunder till Hjärtgruppens inkorg.
    var watchContact = watchForm.getAttribute('data-contact-email');
    var watchFailText = watchContact
      ? interpolate(strings.stockFailEmail || 'Det gick inte just nu. Mejla {email} så ordnar vi det.', { email: watchContact })
      : strings.genericError || 'Det gick inte just nu. Försök igen om en stund.';
    var watchBusy = false;

    /* Knappen ligger avstängd i markupen. Är den fortfarande det står sidan
       utan JS, och noscript-raden med mejladressen är enda vägen vidare. */
    if (watchButton) watchButton.disabled = false;

    var showStatus = function (message, isError) {
      if (!watchStatus) return;
      watchStatus.textContent = message;
      watchStatus.hidden = false;
      watchStatus.classList.toggle('pdp-notify__ok--error', Boolean(isError));
    };

    /* Kvittot ersätter fältet — står formuläret kvar ser det ut som att
       anmälan inte gick igenom, och adressen skickas en gång till. */
    var closeForm = function (message) {
      if (watchRow) watchRow.hidden = true;
      if (watchLede) watchLede.hidden = true;
      showStatus(message, false);
    };

    watchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (watchBusy) return;

      var endpoint = watchForm.getAttribute('data-endpoint');
      var variant = watchForm.getAttribute('data-variant');
      var email = watchEmail ? watchEmail.value.trim() : '';

      if (!endpoint || !variant || !email) return;

      watchBusy = true;
      if (watchButton) watchButton.disabled = true;
      showStatus(strings.sending || 'Skickar …', false);

      var body = new URLSearchParams();
      body.set('email', email);
      body.set('variant', variant);
      body.set('foretag', watchForm.foretag ? watchForm.foretag.value : '');

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      })
        .then(function (response) {
          return response.json().catch(function () {
            return { ok: false, error: 'server' };
          });
        })
        .then(function (data) {
          if (data && data.ok && data.status === 'in_stock') {
            /* Sidan är cachad av Shopifys CDN och kan vara minuter gammal —
               varan hann komma in medan besökaren läste. */
            closeForm(strings.stockInStock || 'Varan finns redan i lager igen — ladda om sidan så syns köpknappen.');
            return;
          }

          if (data && data.ok) {
            closeForm(
              data.status === 'already'
                ? strings.stockAlready || 'Du bevakar redan varan — vi mejlar när den är inne igen.'
                : strings.stockSuccess || 'Klart. Vi mejlar automatiskt när varan är inne igen.'
            );
            return;
          }

          var reason = data && data.error;
          if (reason === 'email') {
            showStatus(strings.emailError || 'Kontrollera adressen och försök igen.', true);
          } else if (reason === 'rate') {
            showStatus(strings.rateLimitError || 'För många anmälningar just nu. Försök igen om en stund.', true);
          } else {
            showStatus(watchFailText, true);
          }

          watchBusy = false;
          if (watchButton) watchButton.disabled = false;
        })
        .catch(function () {
          showStatus(watchFailText, true);
          watchBusy = false;
          if (watchButton) watchButton.disabled = false;
        });
    });
  }

  initWatch(document.querySelector('[data-stock-watch]'));

  /* Variantbytet utan omladdning (2026-10-07). Väljarens värden är vanliga
     länkar till ?variant= (snippets/variant-options.liquid). Här fångas
     klicket, sektionen hämtas via Section Rendering och köpblocket och den
     fasta raden ersätts. Liquid förblir enda sanningen om pris, lager,
     antalstak och kundvagnsrad — inget av det räknas om i JS.

     Ovald storlek: utan ?variant= renderar Liquid storleksgruppen ovald och
     köpknappen avstängd. Men varje länk bär en hel variant, så ett färgval
     hade annars fyllt i storleken åt kunden. Därför minns sidan vilka
     storleksgrupper kunden själv valt, och resten återställs till ovalda
     efter varje byte. */
  var buyStart = document.querySelector('[data-pdp-buy]');

  if (buyStart && window.fetch && window.DOMParser) {
    var swapToken = 0;
    var unchosen = {};
    var startGroups = buyStart.querySelectorAll('[data-pdp-option]');
    Array.prototype.forEach.call(startGroups, function (group, index) {
      if (group.hasAttribute('data-option-unchosen')) unchosen[index] = true;
    });
    var chooseValue = buyStart.querySelector(
      '[data-option-unchosen] .pdp-opt__label-value, [data-option-unchosen] .pdp-opt__field-value'
    );
    var chooseWord = chooseValue ? chooseValue.textContent.trim() : '';

    var applyUnchosen = function (root) {
      var pending = false;
      var chooseText = '';
      Array.prototype.forEach.call(root.querySelectorAll('[data-pdp-option]'), function (group, index) {
        if (!unchosen[index]) return;
        pending = true;
        if (!chooseText) chooseText = group.getAttribute('data-choose-text') || '';
        group.setAttribute('data-option-unchosen', '');
        Array.prototype.forEach.call(group.querySelectorAll('[aria-current]'), function (el) {
          el.removeAttribute('aria-current');
        });
        var value = group.querySelector('.pdp-opt__label-value, .pdp-opt__field-value');
        if (value && chooseWord) value.textContent = chooseWord;
      });
      if (!pending) return false;

      var add = root.querySelector('.pdp-buy__add');
      if (add) {
        add.disabled = true;
        if (chooseText) add.textContent = chooseText;
      }
      var availability = root.querySelector('.pdp-buy__availability');
      if (availability) availability.remove();
      var form = root.querySelector('.pdp-buy__form');
      if (form) form.removeAttribute('data-cart-line-control');
      return true;
    };

    var swapVariant = function (link) {
      var root = document.querySelector('[data-pdp-buy]');
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-option]'));
      var group = link.closest('[data-pdp-option]');
      var groupIndex = groups.indexOf(group);
      var isSize = group && group.hasAttribute('data-option-size');
      var hadFocus = document.activeElement === link;
      var variantId = link.getAttribute('data-variant-id');
      var href = link.getAttribute('href');
      var pageUrl = window.location.pathname + '?variant=' + encodeURIComponent(variantId);
      var token = ++swapToken;

      delete unchosen[groupIndex];
      root.setAttribute('aria-busy', 'true');

      fetch(href + (href.indexOf('?') < 0 ? '?' : '&') + 'section_id=' + encodeURIComponent(root.getAttribute('data-section-id')), {
        credentials: 'same-origin',
      })
        .then(function (response) {
          if (!response.ok) throw new Error('section ' + response.status);
          return response.text();
        })
        .then(function (html) {
          if (token !== swapToken) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-pdp-buy]');
          if (!next) throw new Error('no buy block');

          var pending = applyUnchosen(next);
          var current = document.querySelector('[data-pdp-buy]');
          var section = current.closest('.shopify-section') || current.parentNode;
          current.replaceWith(next);

          var oldSticky = document.querySelector('[data-pdp-sticky]');
          var newSticky = pending ? null : doc.querySelector('[data-pdp-sticky]');
          if (oldSticky && newSticky) {
            oldSticky.replaceWith(newSticky);
          } else if (oldSticky) {
            oldSticky.remove();
          } else if (newSticky) {
            section.appendChild(newSticky);
          }

          /* Bilden följer färgen, inte storleken: ett storleksval ska inte
             kasta tillbaka kunden till bild ett i galleriet. */
          if (!isSize) {
            var checked = doc.querySelector('.pdp-gallery__radio:checked');
            var radio = checked && document.getElementById(checked.id);
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          window.history.replaceState(window.history.state, '', pageUrl);

          if (window.themeSavedProducts) window.themeSavedProducts.syncButtons(next);
          document.dispatchEvent(new CustomEvent('product-cards:added', { detail: { root: next } }));
          if (newSticky) {
            document.dispatchEvent(new CustomEvent('product-cards:added', { detail: { root: newSticky } }));
          }
          initWatch(next.querySelector('[data-stock-watch]'));
          updateTiers();
          syncSticky();
          document.dispatchEvent(new CustomEvent('pdp:variant-changed', { detail: { variantId: variantId } }));

          if (hadFocus) {
            var nextGroup = next.querySelectorAll('[data-pdp-option]')[groupIndex];
            var target = nextGroup && (
              nextGroup.querySelector('[data-variant-id="' + variantId + '"]') ||
              nextGroup.querySelector('.pdp-opt__value')
            );
            if (target) target.focus({ preventScroll: true });
          }
        })
        .catch(function () {
          /* Hellre en vanlig sidladdning än ett köpblock som står och väntar. */
          window.location.href = href;
        });
    };

    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target.closest('[data-pdp-buy] .pdp-opt__value[data-variant-id]');
      if (!link) return;
      event.preventDefault();
      var select = link.closest('[data-pdp-select]');
      if (select) select.open = false;
      swapVariant(link);
    });
  }

  /* Listväljaren är ett <details>. Stäng den med krysset, Escape, ett klick
     utanför — och på mobil ett tryck på den tonade bakgrunden, som är
     elementets eget ::before och därför träffar <details> själv. */
  document.addEventListener('click', function (event) {
    var close = event.target.closest('[data-pdp-select-close]');
    if (close) {
      close.closest('[data-pdp-select]').open = false;
      return;
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-select][open]'), function (select) {
      if (event.target === select || !select.contains(event.target)) select.open = false;
    });
  });

  /* Listans miniatyrer är lazy och laddades först när arket öppnats — en
     sekunds tomma cirklar. Hämta dem redan vid tryck på fältet. */
  document.addEventListener('pointerdown', function (event) {
    var summary = event.target.closest('[data-pdp-select] > summary');
    if (!summary) return;
    Array.prototype.forEach.call(summary.parentNode.querySelectorAll('img[loading="lazy"]'), function (img) {
      img.loading = 'eager';
    });
  }, { passive: true });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-select][open]'), function (select) {
      select.open = false;
      var summary = select.querySelector('summary');
      if (summary) summary.focus();
    });
  });
})();
